export const Roles = [
  { id: "USER", name: "User" },
  { id: "ADMIN", name: "Admin" },
];
